var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#fff",
    stroke: "#fff",
    transform: "rotate(180)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u56FE\\u6807",
    stroke: "#fff",
    strokeWidth: 1.5,
    transform: "translate(-250.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6295\\u7968",
    transform: "translate(250.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.003834192,8.58665028 C-0.046970808,8.00235028 0.413604192,7.50000028 1.00007419,7.50000028 L2.90934419,7.50000028 C3.46164419,7.50000028 3.90934419,7.94770028 3.90934419,8.50000028 L3.90934419,18.0000003 C3.90934419,18.5523003 3.46164419,19.0000003 2.90934419,19.0000003 L1.82615919,19.0000003 C1.30745419,19.0000003 0.874854192,18.6034003 0.829919192,18.0866503 L0.003834192,8.58665028 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90934419,8.18725028 C6.90934419,7.76940028 7.16904419,7.39540028 7.54699419,7.21725028 C8.37124419,6.82870028 9.77579419,6.04690028 10.4093442,4.99025028 C11.2258942,3.62845028 11.3798942,1.16797528 11.4049442,0.604390277 C11.4084442,0.525495277 11.4061942,0.446505277 11.4170442,0.368280277 C11.5523942,-0.607769723 13.4364942,0.532460277 14.1593442,1.73806028 C14.5516442,2.39235528 14.6019442,3.25200028 14.5606942,3.92315028 C14.5165442,4.64125028 14.3059942,5.33495028 14.0994442,6.02415028 L13.6593442,7.49225028 L19.0877942,7.49225028 C19.7509442,7.49225028 20.2303942,8.12590028 20.0501442,8.76405028 L17.3649942,18.2718003 C17.2433442,18.7025503 16.8502442,19 16.4026442,19 L7.90934419,19 C7.35704419,19 6.90934419,18.5523003 6.90934419,18 L6.90934419,8.18725028 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbs);
export default __webpack_public_path__ + "static/media/thumbs.bf3a3d681b4c0ec231927f9b3c206cde.svg";
export { ForwardRef as ReactComponent };